import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import MilestoneSwitcherContent from './MilestoneSwitcherContent'
import MilestonesViewModel from '../MilestonesViewModel'
import styles from './MilestoneSwitcher.sass'

/**
 * How long does it take a dropdown to animate?
 * That sounds like a lightbulb joke, hah!
 * @type {Number}
 */
const TRANSITION_DURATION = 200

interface Props {
  vm: MilestonesViewModel
  isCardLayout?: boolean
}

export default observer(function MilestoneSwitcher({
  vm,
  isCardLayout,
}: Props) {
  const { showingMilestoneSwitcher } = vm
  return (
    <div className={cx(styles.root)}>
      <TransitionGroup>
        {showingMilestoneSwitcher && (
          <CSSTransition
            timeout={TRANSITION_DURATION}
            appear
            classNames={{
              enter: styles.animEnter,
              appear: styles.animEnter,
              exit: styles.animLeave,
            }}
          >
            <MilestoneSwitcherContent isCardLayout={isCardLayout} vm={vm} />
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  )
})
